import initCmsPageType from './extension/sw-cms/init/cmsPageType.init';

import './module/sw-settings-seo/component/sw-seo-url';

import './extension/sw-cms/page/sw-cms-detail';
import './extension/sw-settings-cache/page/sw-settings-cache-index';

import './extension/sw-cms/component/sw-cms-create-wizard';
import './extension/sw-cms/component/sw-cms-list-item';

import './extension/entity/sw-entity-many-to-many-select'

import './module/acris-faq-list';
import './module/acris-faq';
import './module/acris-faq-group';

import './module/sw-cms/blocks/bundle/acris-faq';

import './module/sw-cms/elements/acris-faq';
import './module/sw-cms/elements/acris-faq-single';
import './component/acris-faq-keyword-modal-form';
import './component/acris-faq-keyword-card-filter';

import './module/sw-custom-entity/component/sw-generic-cms-page-assignment';
import './module/sw-import-export/component/sw-import-export-edit-profile-general';

initCmsPageType();
